import keys from '@debbie/common/dist/cache/keys.js';
import { useMutation } from '@debbie/common/dist/util/hooks.js';
import * as customersAPI from '@debbie/cortex/dist/api/customers.js';
import { customersEntity } from '@debbie/cortex/dist/customers/index.js';
import q from '@debbie/cortex/dist/query.js';
import React from 'react';
import { useSelector } from 'react-redux';
import THEME from '../../../theme.js';
import { errorNotification } from '../../../utils/errors.js';
import Badge from '../../Badge.js';
import { Edit, XCircle } from '../../Icons/index.js';
const SecondaryEntity = (props) => {
    const { id, toggleEditModal, render, note, deleteEventType, enabled } = props;
    const lang = useSelector((s) => s.lang);
    const deleteMutation = useMutation(async () => {
        await customersAPI.addEventToUser(props.user.customerId, props.user.userId, {
            type: deleteEventType,
            details: {
                id,
            },
        });
        q.invalidate(keys.write.modify(customersEntity, props.user.customerId));
    }, {
        onError: (err) => {
            errorNotification(lang, err, 'delete', lang.errorEntities.customer);
        },
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(Edit, { style: {
                cursor: 'pointer',
                float: 'right',
                marginLeft: '5px',
            }, onClick: () => toggleEditModal() }),
        React.createElement(XCircle, { style: {
                cursor: 'pointer',
                float: 'right',
                opacity: deleteMutation.isLoading ? 0.5 : 1,
            }, onClick: () => deleteMutation.mutate() }),
        render,
        note ? React.createElement("small", null,
            " - ",
            note) : '',
        ' ',
        !enabled && (React.createElement(Badge, { theme: THEME.COLOR_ACCENT }, lang.customers.secondaryEntityDisabled))));
};
export default SecondaryEntity;
//# sourceMappingURL=SecondaryEntity.js.map